import { Message } from "@/components/Navigation/Buttons/WishlistButton/components/message/message";
import { useWishlistButtonContext } from "@/components/Navigation/Buttons/WishlistButton/context/wishlistButton.context";
import { Base } from "@/components/Navigation/Buttons/WishlistButton/wishlistButton.base";

export const WishlistButton = Object.assign(Base, {
    useContext: useWishlistButtonContext,
    Message: Message
});
